import React from "react";
import { useDispatch } from "react-redux";
import { NavLink, useRouteMatch } from "react-router-dom";
import {
  setProposalToDeleting,
  setProposalToUpdating,
} from "../../actions/proposal";
import { openModal } from "../../actions/ui";
import { images } from "../../constants";
import { dateFormat } from "../../helper/dateConvertor";
import "./ProposalItem.scss";

const ProposalItem = ({ proposal }) => {
  const createDate = dateFormat(proposal.createddate);

  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const handleDelete = (proposalId) => {
    dispatch(openModal());
    dispatch(setProposalToDeleting(proposalId));
  };
  const handleUpdate = (proposal) => {
    dispatch(setProposalToUpdating(proposal));
  };
  return (
    <div className="proposal-item">
      <div className="proposal-item__heading">
        <div className="proposal-item__heading--img">
          <img src={images.IconProfileR} alt="" />
        </div>
        <div className="proposal-item__heading--name">
          <div className="heading__name">
            <h2 className="title-gray-bold-16">
              {proposal.studentSelected.studentname}
            </h2>
            <h3 className="paragraph-gray-reg-16 ">
              {proposal.studentSelected.studentlastname}
            </h3>
          </div>

          <div className="proposal-item__created-date">
            <h3 className="paragraph-gray-reg-14">created at</h3>
            <span className="title-gray-bold-16">{createDate}</span>
          </div>
        </div>
      </div>
      <div className="proposal-item__heading--buttons">
        <div className="buttons__delete-edit">
          <button
            className="buttonDelete"
            onClick={() => handleDelete(proposal._id)}
          >
            <img src={images.IconDelete} alt="" />
          </button>

          <button onClick={() => handleUpdate(proposal)}>
            <NavLink to={`${path}/section-proposal/${proposal._id}`}>
              <img src={images.IconEdit} alt="" />
            </NavLink>
          </button>
        </div>

        <div className="buttons__link-proposal">
          <a
            href={`${proposal.link}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            See
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProposalItem;
